// extracted by mini-css-extract-plugin
module.exports = {"hotelFacilitiesContainer":"hotel_facilities_section_hotelFacilitiesContainer__6XmsN"};